import React from 'react';

import BacklinkNavigator from 'components/Header/BacklinkNavigator';
import { LoadingPageAnimation } from 'components/LoadingPageAnimation';

import { EurailSearchResults } from './components/EurailSrpResults';
import { EurailSrpSearchForm } from './components/EurailSrpSearchForm';
import { useEurailSearchResultsPage } from './hooks';
import './styles.scss';

const SearchResultsPage: React.FC = () => {
  const isPageReady = true; // Replace with actual page readiness logic
  const { backLinkProps, eurailSearchFormProps, eurailSearchResultsProps } =
    useEurailSearchResultsPage();

  return (
    <>
      <BacklinkNavigator backLinkProps={backLinkProps} />
      {isPageReady && eurailSearchResultsProps ? (
        <>
          <EurailSrpSearchForm {...eurailSearchFormProps} />

          <EurailSearchResults {...eurailSearchResultsProps} />
        </>
      ) : (
        <LoadingPageAnimation />
      )}
    </>
  );
};

export default SearchResultsPage;
